import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Zap({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg width={'20px'} height={'23px'} viewBox={'0 0 20 23'}>
        <g
          stroke={'none'}
          strokeWidth={'1'}
          className={'icon__fill'}
          fillRule={'evenodd'}
        >
          <g transform={'translate(-2.000000, -1.000000)'} fillRule={'nonzero'}>
            <path
              d={
                'M10.8672178,15 L3,15 C2.15216235,15 1.68900628,14.0111425 2.23177872,13.3598156 L12.2317787,1.3598156 C12.8710317,0.592712083 14.1161321,1.13320062 13.9922779,2.12403473 L13.1327822,9 L21,9 C21.8478376,9 22.3109937,9.98885748 21.7682213,10.6401844 L11.7682213,22.6401844 C11.1289683,23.4072879 9.88386786,22.8667994 10.0077221,21.8759653 L10.8672178,15 Z M11.5846606,5.26045717 L5.13504161,13 L12,13 C12.601498,13 13.0668845,13.5271816 12.9922779,14.1240347 L12.4153394,18.7395428 L18.8649584,11 L12,11 C11.398502,11 10.9331155,10.4728184 11.0077221,9.87596527 L11.5846606,5.26045717 Z'
              }
            ></path>
          </g>
        </g>
      </svg>
    </div>
  )
}

Zap.propTypes = {
  className: PropTypes.string,
}
